import { museumApiBaseUrl } from '~/constants/museum'
import { Athlete } from '~/domain/Athlete'

export const getAthlete = async (trophyId: string): Promise<Athlete> => {
  const method = 'GET'
  const path = `${museumApiBaseUrl}/trophies/${trophyId}/user/profile`
  const response = await fetch(path, { method })

  if (!response.ok) throw new Error(`Cannot get athlete: ${response.status}`)

  return await response.json()
}

export const getFeaturedAthletes = (): Athlete[] => {
  return [
    {
      id: '22dc8845-7503-4efc-8ba8-3674ef21d85b',
      name: 'Isaiah Wayne Christophe',
      country: 'Canada',
      flagUrl: 'https://cdn.leverade.com/market/flags/canada.jpg',
      sport: 'Para Athletics',
      museumUrl: 'https://museum.belegends.com/gallery/isaiahchristophe',
      featuredImageUrl: 'https://cdn.leverade.com/market/athletes/22dc8845-7503-4efc-8ba8-3674ef21d85b.featured.jpg',
    },
    {
      id: '485e7916-e11d-4966-9a44-228d9ffee37f',
      name: 'Erwin Jan Feuchtmann Pérez',
      country: 'Chile',
      flagUrl: 'https://cdn.leverade.com/market/flags/chile.jpg',
      sport: 'Handball',
      museumUrl: 'https://museum.belegends.com/gallery/erwinfeuchtmann',
      featuredImageUrl: 'https://cdn.leverade.com/market/athletes/485e7916-e11d-4966-9a44-228d9ffee37f.featured.jpg',
    },
    {
      id: '8dd30a7c-768f-42d1-a2a9-9d313c9165a9',
      name: 'Brian Lionel Impellizzeri',
      country: 'Argentina',
      flagUrl: 'https://cdn.leverade.com/market/flags/argentina.jpg',
      sport: 'Para Athletics',
      museumUrl: 'https://museum.belegends.com/gallery/brianimpellizzeriok',
      featuredImageUrl: 'https://cdn.leverade.com/market/athletes/8dd30a7c-768f-42d1-a2a9-9d313c9165a9.featured.jpg',
    },
    {
      id: 'ae04da84-298a-4d67-9aa1-609a79346917',
      name: 'Bruno Cetraro Berriolo',
      country: 'Uruguay',
      flagUrl: 'https://cdn.leverade.com/market/flags/uruguay.jpg',
      sport: 'Rowing',
      museumUrl: 'https://museum.belegends.com/gallery/brunocetraro',
      featuredImageUrl: 'https://cdn.leverade.com/market/athletes/ae04da84-298a-4d67-9aa1-609a79346917.featured.jpg',
    },
    {
      id: 'ba007c27-2a0f-4233-8273-9d105087efef',
      name: 'Perez Diaz Luis Jabdiel',
      country: 'Puerto Rico',
      flagUrl: 'https://cdn.leverade.com/market/flags/puertorico.jpg',
      sport: 'Judo',
      featuredImageUrl: 'https://cdn.leverade.com/market/athletes/ba007c27-2a0f-4233-8273-9d105087efef.featured.jpg',
    },
    {
      id: 'df3c60f2-578b-463e-8ad6-97f9c71a16b6',
      name: 'Hinestroza Asprilla Yuliett Iveth',
      country: 'Panama',
      flagUrl: 'https://cdn.leverade.com/market/flags/panama.jpg',
      sport: 'Box',
      featuredImageUrl: 'https://cdn.leverade.com/market/athletes/df3c60f2-578b-463e-8ad6-97f9c71a16b6.featured.jpg',
    },
    {
      id: '70b47670-d96d-4390-8a91-286fcdad21c2',
      name: 'Yaseen Aref El-Demerdash',
      country: 'USA',
      flagUrl: 'https://cdn.leverade.com/market/flags/usa.jpg',
      sport: 'Para Swimming',
      museumUrl: 'https://museum.belegends.com/gallery/yaseeneld',
      featuredImageUrl: 'https://cdn.leverade.com/market/athletes/70b47670-d96d-4390-8a91-286fcdad21c2.featured.jpg',
    },
    {
      id: 'e16414f2-1495-433e-b5d6-736a04635d3d',
      name: 'Javier Alejandro Saiz',
      country: 'Argentina',
      flagUrl: 'https://cdn.leverade.com/market/flags/argentina.jpg',
      sport: 'Basketball',
      featuredImageUrl: 'https://cdn.leverade.com/market/athletes/e16414f2-1495-433e-b5d6-736a04635d3d.featured.jpg',
    },
    {
      id: '8dbb9258-de75-4e46-bd3f-9bc80d9985ff',
      name: 'Hannah Macneil',
      country: 'Canada',
      flagUrl: 'https://cdn.leverade.com/market/flags/canada.jpg',
      sport: 'Swimming',
      museumUrl: 'https://museum.belegends.com/gallery/macnmagg',
      featuredImageUrl: 'https://cdn.leverade.com/market/athletes/8dbb9258-de75-4e46-bd3f-9bc80d9985ff.featured.jpg',
    },
    {
      id: '826cc2d4-fe09-44f8-8010-183fd26d43fb',
      name: 'Magalí Vilches',
      country: 'Argentina',
      flagUrl: 'https://cdn.leverade.com/market/flags/argentina.jpg',
      sport: 'Basketball',
      museumUrl: 'https://museum.belegends.com/gallery/magalivilches',
      featuredImageUrl: 'https://cdn.leverade.com/market/athletes/826cc2d4-fe09-44f8-8010-183fd26d43fb.featured.jpg',
    },
    {
      id: '56a97980-fb03-4929-98e9-d39d1926f77b',
      name: 'Tracy Otto',
      country: 'USA',
      flagUrl: 'https://cdn.leverade.com/market/flags/usa.jpg',
      sport: 'Para Archery',
      museumUrl: 'https://museum.belegends.com/gallery/tracyotto',
      featuredImageUrl: 'https://cdn.leverade.com/market/athletes/56a97980-fb03-4929-98e9-d39d1926f77b.featured.jpg',
    },
    {
      id: '65870f09-5832-46a0-a630-0b40913ae55a',
      name: 'Furkan Serbest',
      country: 'Turkey',
      flagUrl: 'https://cdn.leverade.com/market/flags/turkey.jpg',
      sport: 'Water Polo',
      museumUrl: 'https://museum.belegends.com/gallery/furkanserbest',
      featuredImageUrl: 'https://cdn.leverade.com/market/athletes/65870f09-5832-46a0-a630-0b40913ae55a.featured.jpg',
    },
  ]
}
